<template>
    <ul class="menu" v-if="bookPortal">
        <li>
            <a :href="$getSubdomainLink('portal', '/books/catalog')" class="menu__item">
                Books
            </a>
        </li>
    </ul>
    <ul class="menu" v-else>
        <li>
            <a :href="$getSubdomainLink('portal', '/video/catalog')" class="menu__item">
                Inspiration
            </a>
        </li>
        <li>
            <a :href="$getSubdomainLink('portal', '/planner')" class="menu__item">
                Planner
            </a>
        </li>
        <li>
            <a :href="$getSubdomainLink('portal', '/books/catalog')" class="menu__item">
                Books
            </a>
        </li>
        <li>
            <a :href="$getSubdomainLink('portal', '/blog/catalog')" class="menu__item">
                Blog
            </a>
        </li>
    </ul>
</template>

<script>
export default {
  props: {
    bookPortal: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
